var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('EditorInput',{attrs:{"placeholder":_vm.placeholder,"class_style":_vm.class_style,"disabled":_vm.disabled,"id":_vm.id,"prop_text":_vm.prop_text},on:{"onChangeContent":_vm.onEditorInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }